import { NgModule, ModuleWithProviders, LOCALE_ID } from '@angular/core'
import { TranslateModule, TranslateCompiler, MissingTranslationHandler } from '@ngx-translate/core'
import { TranslateMessageFormatCompiler, MESSAGE_FORMAT_CONFIG } from 'ngx-translate-messageformat-compiler'
import { CustomMissingTranslationHandler, LocaleService } from './services/locale.service'

export function TranslateMessageFormatCompilerFactory () {
  return new TranslateMessageFormatCompiler()
}

@NgModule({
  exports: [
    TranslateModule,
  ],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LocaleModule {
  static forRoot (): ModuleWithProviders<LocaleModule> {
    const translateModule = TranslateModule.forRoot({
      defaultLanguage: 'en',
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
      compiler: {
        provide: TranslateCompiler,
        useFactory: TranslateMessageFormatCompilerFactory,
      },
    })

    return {
      ngModule: LocaleModule,
      providers: [
        {
          provide: LOCALE_ID,
          deps: [LocaleService],
          useFactory: locale => locale.getLocale(),
        },
        {
          provide: MESSAGE_FORMAT_CONFIG,
          useValue: LocaleService.allLocales,
        },
        ...translateModule.providers!,
      ],
    }
  }

  static forChild (): ModuleWithProviders<LocaleModule> {
    const translateModule = TranslateModule.forChild({
      extend: true,
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
    })

    return {
      ngModule: LocaleModule,
      providers: translateModule.providers!,
    }
  }
}

export { LocaleService, AngularJSLocaleService, gettext } from './services/locale.service'
